import { render } from "./TopProductStock.vue?vue&type=template&id=7165b04d&ts=true"
import script from "./TopProductStock.vue?vue&type=script&lang=ts"
export * from "./TopProductStock.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__